<template>
  <div
    class="frisbuy-sr-stories"
    :style="{ ...formatSizeCompute }"
    ref="storyList"
  >
    <FrisbuySrStory
      v-for="story in stories"
      :key="story.instagramPost.frisbuyId"
      :style="style__FrisbuySrStory"
      @click="(story, event) => $emit('selectStory', story, event)"
      :story="story"
      :selectedStory="selectedStory"
      :visited="visited"
      :getMainImage="getMainImage"
      ref="FrisbuySrStory"
    />
  </div>
</template>

<style scoped lang="scss">
.frisbuy-sr-stories {
  flex-grow: 1;
  overflow-y: auto;
  padding: 0 8px;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: -moz-scrollbars-none;

  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
}
</style>

<script>
import FrisbuySrStory from "./FrisbuySrStory.vue";

export default {
  components: { FrisbuySrStory },

  inject: ["settings", "sendAnalyticEvent"],

  data() {
    return {
      canNavigatePrev: false,
      canNavigateNext: false,
    };
  },

  props: {
    stories: {
      type: Array,
      require: false,
      default: () => [],
    },
    selectedStory: {
      require: false,
      default: null,
    },
    visited: {
      type: Array,
      require: false,
      default: () => [],
    },
  },

  emits: ["selectStory", "canNavigatePrev", "canNavigateNext"],

  mounted() {
    this.$nextTick(() => {
      this.onStoriesScroll();
      this.$refs.storyList.addEventListener("scroll", this.onStoriesScroll);
    });
  },

  beforeUnmount() {
    this.$refs.storyList.removeEventListener("scroll", this.onStoriesScroll);
  },

  methods: {
    getMainImage(story, highResolution) {
      return highResolution
        ? story.media[0].imageUrl
        : story.media[0].thumbnailUrl;
    },

    storiesScrolling(direction) {
      if (!this.$refs.storyList) return;

      const storyElement = this.$refs.storyList.firstElementChild;

      this.$refs.storyList.scrollBy(0, storyElement.offsetHeight * direction);

      this.sendAnalyticEvent("Swipe", { swipeType: "arrow" });
    },

    onStoriesScroll() {
      const { storyList } = this.$refs;

      this.canNavigatePrev = Boolean(storyList.scrollTop);
      this.canNavigateNext = Boolean(
        !(
          storyList.scrollHeight > storyList.offsetHeight &&
          storyList.scrollTop < storyList.scrollHeight - storyList.offsetHeight
        )
      );
    },
  },

  computed: {
    style__FrisbuySrStory() {
      return {
        "margin-right":
          this.settings.widget.inlineDesktop == 1
            ? `${this.settings.stories_margin}px`
            : "0",
      };
    },

    formatSizeCompute() {
      // padding сториса
      const wrapperPaddingSize = 2;
      // Пропорции прямоугольного формата
      const aspectRatio = 9 / 16;
      // Дефолтный размер сторис
      const defaultStorySize = 60;

      // Если включен кастомный размер сторис и не включен фиксированный режим
      if (
        this.settings.isCustomSize == "1" &&
        this.settings.widget.inlineDesktop == "1"
      ) {
        return {
          // Размеры для desktop circle
          "--frisbuy-desktop-size": this.settings.pcSize
            ? this.settings.pcSize + "px"
            : `${defaultStorySize}px`,
          // Размеры для mobile circle
          "--frisbuy-mobile-size": this.settings.mobileSize
            ? this.settings.mobileSize + "px"
            : `${defaultStorySize}px`,
          // Размеры для паддинга
          "--frisbuy-story-wrapper-padding": wrapperPaddingSize + "px",
          // Размеры для desktop rectangle. На мобилке он кружками
          "--frisbuy-rectangle-size":
            Math.round(
              ((Number(this.settings.pcSize) || defaultStorySize) +
                wrapperPaddingSize * 2) /
                aspectRatio
            ) + "px",
        };
      }

      // Дефолтный размеры всех форматов сторис
      return {
        "--frisbuy-desktop-size": `${defaultStorySize}px`,
        "--frisbuy-mobile-size": `${defaultStorySize}px`,
        "--frisbuy-story-wrapper-padding": wrapperPaddingSize + "px",
        "--frisbuy-rectangle-size":
          Math.round(
            (defaultStorySize + wrapperPaddingSize * 2) / aspectRatio
          ) + "px",
      };
    },
  },

  watch: {
    canNavigatePrev() {
      this.$emit("canNavigatePrev", this.canNavigatePrev);
    },

    canNavigateNext() {
      this.$emit("canNavigateNext", this.canNavigateNext);
    },
  },
};
</script>
